import React from 'react';
import { Button } from './Button';
import { ShoppingCartIcon } from 'lucide-react';
export interface ProductCardProps {
  title: string;
  price: string;
  category: string;
  isNew?: boolean;
  onAddToCart?: () => void;
}
export function ProductCard({
  title,
  price,
  category,
  isNew,
  onAddToCart
}: ProductCardProps) {
  return <div className="group flex flex-col bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" data-id="element-178">
      {/* Image Placeholder */}
      <div className="relative aspect-square bg-gray-100 p-6 flex items-center justify-center overflow-hidden" data-id="element-179">
        <div className="absolute inset-0 bg-gradient-to-tr from-gray-200 to-gray-50 opacity-50" data-id="element-180"></div>
        <span className="relative text-gray-400 font-medium text-center px-4" data-id="element-181">
          {title} Image
        </span>
        {isNew && <span className="absolute top-3 left-3 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider z-10" data-id="element-182">
            New
          </span>}
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-grow" data-id="element-183">
        <span className="text-xs text-blue-600 font-semibold uppercase tracking-wider mb-1" data-id="element-184">
          {category}
        </span>
        <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2" data-id="element-185">
          {title}
        </h3>
        <div className="mt-auto pt-4 flex items-center justify-between" data-id="element-186">
          <span className="text-xl font-extrabold text-gray-900" data-id="element-187">{price}</span>
          <Button variant="primary" className="!py-2 !px-3" onClick={onAddToCart} aria-label={`Add ${title} to cart`} data-id="element-188">
            <ShoppingCartIcon className="w-5 h-5" data-id="element-189" />
          </Button>
        </div>
      </div>
    </div>;
}